import { render, staticRenderFns } from "./DataPaging.vue?vue&type=template&id=47c0da0a&"
import script from "./DataPaging.vue?vue&type=script&lang=js&"
export * from "./DataPaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.10.1_pcivgqzi2ggw3w32ihxlyfliwi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports